import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mediaEventType' })
export class MediaEventTypePipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    let result = null;
    switch (obj) {
      case 'INJECT':
        result = '장착';
        break;
      case 'EJECT':
        result = '탈착';
        break;
    }
    return result;
  }
}
